import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";

// style
import './slider.css';
import 'swiper/swiper.min.css';

const Slider = ({ sliders }) => {

    if (sliders.length === 0) {
      return null;
    }

    return (
      <section className="about-us__slider">
      <div className="container">
      <Swiper
      loop={false}
      spaceBetween={32}
      slidesPerView={'auto'}
      freeMode={true}
      >
        {sliders.map((item) => (
          <SwiperSlide key={item.id}>
            <img src={item.src} alt={item.alt}></img>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </section>
    )
  };

export default Slider


// WEBPACK FOOTER //
// ./src/page/about-us/slider/slider.js